export const LOGO_ONLY = 'logoOnly';
export const FULL_DESIGN = 'fullDesign';
